export function formatNumberToDinheiro(valor: number): string {
    return `${valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    })}`;
}

export function formatDinheiroToNumber(valor: string): number {
    if (!valor) return 0;

    return Number(
        valor
            .replace("R$", "")
            .replace(/\./g, "")
            .replace(",", ".")
            .trim()
    );
}